/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const ibmRegions = [
  "au-syd",
  "br-sao",
  "ca-mon",
  "ca-tor",
  "eu-de",
  "eu-es",
  "eu-gb",
  "in-che",
  "in-mum",
  "jp-osa",
  "jp-tok",
  "us-east",
  "us-south",
];

export const ibmRegionsOptions = ibmRegions.map((region) => ({
  label: region,
  value: region,
}));
